module.exports={
	"Form": "PhysicalAssetCreateManifest",
	"Scope": "PhysicalAsset-Create",
	"Descriptors":
	{
		"PhysicalAssetDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAsset-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "PhysicalAsset-Create-Identity",
				"Group": "PhysicalAsset-Create-Identity"
			}
		},
		"PhysicalAssetDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAsset-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.OriginLatitude":
		{
			"Name": "Origin Latitude",
			"Hash": "PhysicalAsset-Create-OriginLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.OriginLongitude":
		{
			"Name": "Origin Longitude",
			"Hash": "PhysicalAsset-Create-OriginLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMinLatitude":
		{
			"Name": "Bounding Min Latitude",
			"Hash": "PhysicalAsset-Create-BoundingMinLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMaxLatitude":
		{
			"Name": "Bounding Max Latitude",
			"Hash": "PhysicalAsset-Create-BoundingMaxLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMinLongitude":
		{
			"Name": "Bounding Min Longitude",
			"Hash": "PhysicalAsset-Create-BoundingMinLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMaxLongitude":
		{
			"Name": "Bounding Max Longitude",
			"Hash": "PhysicalAsset-Create-BoundingMaxLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.IDAssetClassification":
		{
			"Name": "Asset Classification",
			"Hash": "PhysicalAsset-Create-IDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details",
				"Entity": "AssetClassification",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"PhysicalAssetDetails.IDAssetType":
		{
			"Name": "Asset Type",
			"Hash": "PhysicalAsset-Create-IDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details",
				"Entity": "AssetType",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"PhysicalAssetDetails.ParentIDPhysicalAsset":
		{
			"Name": "Parent Physical Asset",
			"Hash": "PhysicalAsset-Create-ParentIDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details",
				"Entity": "PhysicalAsset",
				"SearchFields":
				[
					"Name",
					"Description",
					"AssetNumber"
				]
			}
		},
		"PhysicalAssetDetails.ManifestVersion":
		{
			"Name": "Manifest Version",
			"Hash": "PhysicalAsset-Create-ManifestVersion",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.AssetNumber":
		{
			"Name": "Asset Number",
			"Hash": "PhysicalAsset-Create-AssetNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.YearBuilt":
		{
			"Name": "Year Built",
			"Hash": "PhysicalAsset-Create-YearBuilt",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.IDFIPSState":
		{
			"Name": "FIPSState",
			"Hash": "PhysicalAsset-Create-IDFIPSState",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details",
				"Entity": "FIPSState",
				"SearchFields":
				[
					"Code",
					"Name"
				]
			}
		},
		"PhysicalAssetDetails.IDFIPSCounty":
		{
			"Name": "FIPSCounty",
			"Hash": "PhysicalAsset-Create-IDFIPSCounty",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details",
				"Entity": "FIPSCounty",
				"SearchFields":
				[
					"Code",
					"Name"
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAsset-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAsset-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAsset-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAsset-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
